const AVATAR_COLORS = ["#b4441b", "#3b5bdb", "#2b8a3e", "#7048e8", "#c23d68", "#0277bd"];

export function getInstructorName(u) {
  if (!u) return null;
  return (u.fullName || u.name || u.username || "").trim() || null;
}

export function initials(name = "") {
  const p = name.trim().split(/\s+/);
  return p.length >= 2 ? (p[0][0] + p[p.length - 1][0]).toUpperCase() : name.slice(0, 2).toUpperCase();
}

export function colorFor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (name.charCodeAt(i) + ((h << 5) - h)) | 0;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}
